.c-tabs {

    display: flex;

    flex-wrap: wrap;

    align-self: flex-start
}

  .c-tabs > label,
  .c-tabs > a {

    display: flex;

    cursor: pointer;

    z-index: 10;

    padding-left: 0.75rem;

    padding-right: 0.75rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    font-size: 0.875rem;

    font-weight: 500;

    line-height: 1.25rem
}

  @media print {

    .c-tabs > label,
  .c-tabs > a {

        display: none
    }
}

  .c-tabs > label > span, .c-tabs > a > span {

    display: inline-block;

    margin-left: 0.75rem;

    padding-left: 0.625rem;

    padding-right: 0.625rem;

    border-radius: 9999px;

    font-size: 0.75rem;

    font-weight: 500;

    line-height: 1.25rem
}

  .c-tabs > input {

    position: absolute;

    opacity: 0
}

  .c-tabs > div {

    display: none;

    width: 100%;

    order: 9999;

    margin-top: 1px
}

  .c-tabs > input:checked + label + div {

    display: block
}

  .c-tabs--cards > label,
    .c-tabs--cards > a {

    border-top-left-radius: 0.5rem;

    border-top-right-radius: 0.5rem;

    border-width: 1px;

    border-bottom-width: 0px;

    --tw-bg-opacity: 1;

    background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(82 82 91 / var(--tw-text-opacity, 1));

    margin-left: -1px;

    margin-right: 0.5rem;

    padding-left: 1rem;

    padding-right: 1rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem
}

  .c-tabs--cards > label span,
    .c-tabs--cards > a span {

    --tw-bg-opacity: 1;

    background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(24 24 27 / var(--tw-text-opacity, 1))
}

  .c-tabs--cards > label:hover,
    .c-tabs--cards > a:hover {

    --tw-text-opacity: 1;

    color: rgb(39 39 42 / var(--tw-text-opacity, 1))
}

  .c-tabs--cards > label:active {

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(29 78 216 / var(--tw-text-opacity, 1))
}

  .c-tabs--cards > input:checked + label,
    .c-tabs--cards > a.active {

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(29 78 216 / var(--tw-text-opacity, 1))
}

  .c-tabs--cards > input:checked + label span, .c-tabs--cards > a.active span {

    --tw-bg-opacity: 1;

    background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(30 58 138 / var(--tw-text-opacity, 1))
}

  .c-tabs--cards > input:focus + label {

    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);

    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);

    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);

    z-index: 10
}

  .c-tabs--cards > div {

    margin-top: 0px;

    border-top-left-radius: 0px;

    border-top-right-radius: 0px
}

  .c-tabs--pills > label,
    .c-tabs--pills > a {

    border-radius: 0.375rem;

    --tw-text-opacity: 1;

    color: rgb(82 82 91 / var(--tw-text-opacity, 1))
}

  .c-tabs--pills > label span,
    .c-tabs--pills > a span {

    --tw-bg-opacity: 1;

    background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(24 24 27 / var(--tw-text-opacity, 1))
}

  .c-tabs--pills > label:hover,
    .c-tabs--pills > a:hover {

    --tw-text-opacity: 1;

    color: rgb(39 39 42 / var(--tw-text-opacity, 1))
}

  .c-tabs--pills > label:active {

    --tw-bg-opacity: 1;

    background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(39 39 42 / var(--tw-text-opacity, 1))
}

  .c-tabs--pills > input:checked + label,
    .c-tabs--pills > a.active {

    --tw-bg-opacity: 1;

    background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(39 39 42 / var(--tw-text-opacity, 1))
}

  .c-tabs--pills > input:checked + label span, .c-tabs--pills > a.active span {

    --tw-bg-opacity: 1;

    background-color: rgb(212 212 216 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(82 82 91 / var(--tw-text-opacity, 1))
}

  .c-tabs--pills > input:focus + label {

    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);

    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);

    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);

    z-index: 10
}

  .c-tabs--pills > div {

    margin-top: 0.5rem
}

  .c-tabs--underline > label,
    .c-tabs--underline > a {

    --tw-text-opacity: 1;

    color: rgb(113 113 122 / var(--tw-text-opacity, 1));

    border-bottom-width: 2px;

    border-color: transparent;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    padding-left: 0.75rem;

    padding-right: 0.75rem;

    margin-right: 0.5rem
}

  .c-tabs--underline > label span,
    .c-tabs--underline > a span {

    --tw-bg-opacity: 1;

    background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(24 24 27 / var(--tw-text-opacity, 1))
}

  .c-tabs--underline > label:hover,
    .c-tabs--underline > a:hover {

    --tw-text-opacity: 1;

    color: rgb(63 63 70 / var(--tw-text-opacity, 1));

    --tw-border-opacity: 1;

    border-color: rgb(212 212 216 / var(--tw-border-opacity, 1))
}

  .c-tabs--underline > label:active,
    .c-tabs--underline > a.active,
    .c-tabs--underline > input:checked + label {

    --tw-text-opacity: 1;

    color: rgb(30 58 138 / var(--tw-text-opacity, 1));

    --tw-border-opacity: 1;

    border-color: rgb(37 99 235 / var(--tw-border-opacity, 1))
}

  .c-tabs--underline > label:active span, .c-tabs--underline > a.active span, .c-tabs--underline > input:checked + label span {

    --tw-bg-opacity: 1;

    background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(30 58 138 / var(--tw-text-opacity, 1))
}

/*# sourceMappingURL=data:application/json;base64,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 */